// Fetches and injects SVGs into the DOM when they scroll into view
import Loader from "@/javascript/components/loader"

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return

    const el = entry.target
    observer.unobserve(el)

    fetch(el.dataset.lazySvg)
      .then((response) => {
        if (!response.ok) return
        return response.text()
      })
      .then((text) => {
        if (!text) return
        const doc = new DOMParser().parseFromString(text, 'image/svg+xml')
        const svg = doc.documentElement
        if (svg.nodeName === 'svg') el.appendChild(svg)
      })
      .catch(() => {})
  })
})

Loader.functional((content, resolve) => {
  content.querySelectorAll('[data-lazy-svg]').forEach((el) => observer.observe(el))
  resolve()
})
